module.exports = __webpack_public_path__ + "img/entrance_statistics_existing.d70601a0.svg";